module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/kimono/irouchikake-95aa33fb4559c3e2c52dd3fc7310a7be.jpg";